import { languageStore } from '../store/language'

export const languageMixin = {
  computed: {
    currentLanguage() {
      return languageStore.currentLanguage
    }
  },
  methods: {
    /**
     * Get text in current language from an object
     * @param {Object|String} obj - Content object or direct string
     * @param {String} key - Property name (e.g., 'title', 'description')
     * @returns {String} - Text in current language
     */
    getText(obj, key = null) {
      if (!obj) return ''
      if (typeof obj === 'string') return obj

      const lang = this.currentLanguage

      // If no key provided, look for language-specific properties
      if (!key) {
        if (lang === 'en') return obj.en || obj.english || ''
        if (lang === 'zh-Hant') return obj.zhHant || obj.zh || obj.chinese || ''
        return obj.zhHans || obj.zh || obj.chinese || ''
      }

      // With key, look for key + language suffix
      if (lang === 'en') {
        return obj[key] || obj[`${key}En`] || ''
      } else if (lang === 'zh-Hant') {
        return obj[`${key}ZhHant`] || obj[`${key}Zh`] || obj[key] || ''
      } else {
        return obj[`${key}ZhHans`] || obj[`${key}Zh`] || obj[key] || ''
      }
    },

    /**
     * Get simple translation for common UI text
     */
    t(en, zhHant, zhHans) {
      if (this.currentLanguage === 'en') return en
      if (this.currentLanguage === 'zh-Hant') return zhHant
      return zhHans
    }
  }
}
